import {operate, register, password, captcha as captchaApi} from '../boss-web';

// 登录
export const login = (params, config) => operate(params, `web/password.do`, config);

// 账号登出
export const logout = (params, config) => operate(params, 'web/logout.do', config)

// 获取加密因子
export const getIndex = (params, config) => operate(params, 'encryption/factor.do', config)

// 忘记密码获取验证码
export const getValidCode = (params, config) => register(params, 'sendRegisterSms.do', config)

// 校验短信验证码
export const validSMSCode = (params, config) => register(params, 'verifyRegisterSms.do', config)

// 账号管理修改密码
export const updatePassword = (params, config) => password(params, 'update.do', config)

// 忘记密码设置密码
export const editPassword = (params, config) => password(params, 'resetPwd.do', config)

// 使用商户身份认证修改手机号
export const MerchantIdentifierValid = (params, config) => password(params, 'verifyPersonalInfo.do', config)

//  账号管理更改商户手机号
export const updateMerchantPhone = (params, config) => password(params, 'updateAccountAndPwdBySms.do', config)

// 验证码图片地址
export const captchas = captchaApi;
